<template>
  <div
    v-bind:class="{ 
      'background': !isSimulation, 
      'background-simulation': isSimulation 
    }"
    :style="{ 'border-radius': isSimulation ? borderRadius : 0 }"
  >
    <v-carousel
      continuous
      :cycle="!isSimulation"
      hide-delimiters
      :show-arrows="false"
      height="100%"
      :style="{
        'border-radius': isSimulation ? borderRadius : 0,
        'height': isMenu ? 'calc(90vh)' : '100%',
        'background-color': BGColor
      }"
    >
      <v-carousel-item
        v-for="(item,i) in Carousel"
        :key="i"
        :src="item"
        style="height: 100%;"
      />
    </v-carousel>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import constants from '@/constants'
  export default {
    data () {
      return {
      }
    },
    computed: {
      ...mapState('app',['Carousel', 'BGColor']),
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isMenu () {
        return constants.menusRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      borderRadius () {
        return this.isSimulation ? constants.borderRadius : null
      }
    }
  }
</script>
<style scoped>
  .background-simulation {
    position: absolute;
    width: 375px;
    height: 100%;
    min-height: 360px;
  }
  .background {
    position: fixed;
    width: 100%;
    height: calc(100vh);
  }
</style>
